<div
  class="voucher-banner"
  (click)="toggleCoupons()"
  *ngIf="availableVouchersLength > 0 && showVoucherBanner"
>
  <img src="assets/images/icons/coupon.svg" alt="" />

  <span *ngIf="availableVouchersLength === 1">
    {{ 'sharedModule.bkgVoucherBanner.title_singular' | translate }}
  </span>
  <span *ngIf="availableVouchersLength !== 1">
    {{
      'sharedModule.bkgVoucherBanner.title_plural'
        | translate: { count: availableVouchersLength }
    }}
  </span>
  <span class="chevron" [class.open]="isExpanded"></span>
</div>

<div class="voucher-list" *ngIf="isExpanded">
  <div class="voucher-list__text">
    {{ 'sharedModule.bkgVoucherBanner.body' | translate }}
    <span (click)="toggleCoupons()"> {{ 'common.close' | translate }} × </span>
  </div>

  <div class="coupon-container">
    <bkg-voucher-list
      *ngIf="isExpanded"
      [vouchers]="availableVouchers"
      [selectedVoucherCode]="selectedVoucherCode"
      (addVoucherCodeReturn)="onCouponSelected($event)"
    ></bkg-voucher-list>
  </div>
</div>
